import type { PostHostedIdentifySessionData } from '@onefootprint/request-types';
import type { RouterContext } from '@/idv2/routes/router-context';
import { getValidatedIdentifyBootstrap } from './validate-bootstrap';

type IdentifySessionContext = Pick<
  RouterContext,
  | 'config'
  | 'initialAuthToken'
  | 'isComponentsSdk'
  | 'kybBootstrapData'
  | 'kycBootstrapData'
  | 'obConfigAuth'
  | 'sandboxId'
  | 'scope'
>;

export const getIdentifySessionRequest = (
  context: IdentifySessionContext,
): Pick<PostHostedIdentifySessionData, 'body' | 'headers'> => {
  const componentsSdkHeader = context.isComponentsSdk === true ? { 'X-Fp-Is-Components-Sdk': true } : {};

  // The backend rejects bootstrap data or a sandbox ID sent alongside a user auth token
  if (context.initialAuthToken) {
    return {
      body: { data: {}, scope: context.scope },
      headers: { ...context.obConfigAuth, 'X-Fp-Authorization': context.initialAuthToken, ...componentsSdkHeader },
    };
  }

  const bootstrap = getValidatedIdentifyBootstrap(context.kycBootstrapData, context.kybBootstrapData);
  const isLive = context.config?.isLive ?? true;
  const sandboxId = !isLive ? context.sandboxId : undefined;
  return {
    body: { data: bootstrap.data, scope: context.scope },
    headers: {
      ...context.obConfigAuth,
      ...(bootstrap.isBootstrap ? { 'X-Fp-Is-Bootstrap': true } : {}),
      ...(sandboxId ? { 'X-Sandbox-Id': sandboxId } : {}),
      ...componentsSdkHeader,
    },
  };
};
